import React, { useReducer } from "react";
import axios from "axios";
import mainContext from "./mainContext";
import mainReducer from "./mainReducer";
import {
  STRIPE_CUSTOMER,
  STRIPE_SUBSCRIPTION_EXTENDED,
  STRIPE_SUBSCRIPTION_PREVIEW,
  STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING,
  STRIPE_INVOICE,
  LOGIN,
  SEARCH,
  CHANGE_TAB,
  POST_CREATE_TEAM,
  MARK_INVOICE_SENT,
  DEMO_FLOW_DONE,
  GET_MEMBER,
  GET_TEAM,
  STRIPE_PRICE_CONFIG,
  POST_UPGRADE_TEAM,
  POST_SET_EMAIL_STEP,
  SET_ENV,
  STRIPE_CUTOMER_PAYMENT_METHODS,
  GET_HR_CONNECTIONS,
  GET_AD_GROUPS,
  GET_AD_GROUP_USERS,
  UPDATE_HR_CONNECTION_SYNC_CONF,
  GET_MS_AD_MAPPING_CONF,
  POST_CREATE_DEMO_TEAM,
  PATCH_UPDATE_DEMO_TEAM,
  ALERT,
  LOOKUP_TEXT,
  GET_DEMO_TEAMS,
  GET_INTEGRATION_CONNECTIONS,
  GET_DEVICES_FOR_MEMBER,
  GET_LINKS_DATA,
  GET_TEAM_SALESFORCE_DATA,
  GET_MEMBER_CRM_EXPORT_LOGS,
  GET_TEAM_CRM_EXPORT_LOGS,
} from "./types";
import { axiosInstance, axiosParagonInstance } from "../../utilities/axios.config";
import getMemberCount from "../../utilities/getMemberCount";

const MainState = (props) => {
  const initialState = {
    user: null,
    currentTab: 0,
    teamSalesforceData: null,
    listOfApps: [
      // {
      //   title: "Create custom Stripe subscription",
      //   description: "Edit, manage, or create a team's Stripe subscription",
      //   tabName: "Custom Billing",
      //   tabId: 1,
      // },
      {
        title: "Search for members and teams",
        description: "Query the database for specific users and teams",
        tabName: "Search",
        tabId: 2,
        permissions: {
          search: true,
        },
      },
      {
        title: "Create New Team",
        description: "Create a new team and initialize a subscription",
        tabName: "Create New Team",
        tabId: 3,
        permissions: {
          sales: true,
        },
      },
      {
        title: "Checkout Links",
        description: "Get direct checkout links for sharing",
        tabName: "Checkout Links",
        tabId: 4,
        permissions: {
          sales: true,
        },
      },
      {
        title: "Create a Quote",
        description: "Make a PDF Quote",
        tabName: "Create a Quote",
        tabId: 5,
        permissions: {
          sales: true,
        },
      },
      {
        title: "HR Sync",
        description: "Get users data from ad",
        tabName: "HR Sync",
        tabId: 6,
        permissions: {
          admin: true,
        },
      },
      {
        title: "Quotes",
        description: "List of AE's quotes",
        tabName: "Quotes",
        tabId: 7,
        permissions: {
          admin: true,
        },
      },
    ],
    AEDemoTeams: [],
    stripe_customer: null,
    stripe_customer_payment_methods: null,
    stripe_subscription_preview: null,
    stripe_subscription_preview_new_billing: null,
    stripe_subscription_extended: null,
    stripe_invoice: null,
    postDemoFlowStoredEmail: "",
    postDemoFlowStoredTeamId: 0,
    postDemoFlowStoredTeamSize: 0,
    postDemoFlowStoredLoginToken: null,
    postDemoFlowStoredpriceId: "",
    postDemoTeamCreated: false,
    postDemoFlowUpgrade: false,
    invoiceSent: false,
    postDemoFlowFinished: false,
    member: null,
    isProd: true,
    adGroupUsers: {},
    inputLookupText: "",
    integrationConnections: null,
    memberTeam: null,
    linksData: null,
    memberDevices: null,
    snackbarData: {
      isOpen: false,
      severity: "",
      duration: 0,
      message: "",
    },
    crmExportLogs: null,
  };

  const [state, dispatch] = useReducer(mainReducer, initialState);

  // Functions

  const snackbarAction = (snackbarData) => {
    dispatch({
      type: ALERT,
      payload: snackbarData,
    });
  };

  const onChangeInputLookupText = (lookupData) => {
    dispatch({
      type: LOOKUP_TEXT,
      payload: lookupData,
    });
  };

  const resetTeamState = () => {
    dispatch({
      type: GET_TEAM,
      payload: null,
    });
    dispatch({
      type: GET_TEAM_SALESFORCE_DATA,
      payload: null,
    });
    dispatch({
      type: GET_INTEGRATION_CONNECTIONS,
      payload: null,
    });
  };

  const resetMemberState = () => {
    dispatch({
      type: GET_MEMBER,
      payload: null,
    });

    dispatch({
      type: GET_INTEGRATION_CONNECTIONS,
      payload: null,
    });

    dispatch({
      type: GET_LINKS_DATA,
      payload: null,
    });
  };

  const resetState = () => {
    dispatch({
      type: STRIPE_CUSTOMER,
      payload: null,
    });
    dispatch({
      type: STRIPE_CUTOMER_PAYMENT_METHODS,
      payload: null,
    });
    dispatch({
      type: STRIPE_SUBSCRIPTION_EXTENDED,
      payload: null,
    });
    dispatch({
      type: STRIPE_SUBSCRIPTION_PREVIEW,
      payload: null,
    });
    dispatch({
      type: STRIPE_INVOICE,
      payload: null,
    });
    dispatch({
      type: SEARCH,
      payload: null,
    });
    dispatch({
      type: GET_MEMBER,
      payload: null,
    });
    dispatch({
      type: GET_TEAM,
      payload: null,
    });
    dispatch({
      type: GET_HR_CONNECTIONS,
      payload: null,
    });
    dispatch({
      type: POST_SET_EMAIL_STEP,
      email: null,
    });
    dispatch({
      type: GET_AD_GROUPS,
      payload: null,
    });
    dispatch({
      type: GET_AD_GROUP_USERS,
      payload: {},
    });
    dispatch({
      type: GET_MS_AD_MAPPING_CONF,
      payload: null,
    });
  };

  const changeTab = (tab) => {
    dispatch({
      type: CHANGE_TAB,
      payload: tab,
    });
  };

  const logout = () => {
    localStorage.removeItem("@qrToken");
    dispatch({
      type: LOGIN,
      payload: null,
    });
    resetState();

    // Redirect to login
    window.location.href = "/";
  };

  const resetDemoTeamState = () => {
    dispatch({
      type: STRIPE_CUTOMER_PAYMENT_METHODS,
      payload: null,
    });
    dispatch({
      type: STRIPE_SUBSCRIPTION_EXTENDED,
      payload: null,
    });
    dispatch({
      type: STRIPE_SUBSCRIPTION_PREVIEW,
      payload: null,
    });
    dispatch({
      type: STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING,
      payload: null,
    });
    dispatch({
      type: STRIPE_INVOICE,
      payload: null,
    });
    dispatch({
      type: POST_CREATE_DEMO_TEAM,
      postDemoTeamCreated: false,
    });
  };

  const resetPreviewState = () => {
    dispatch({
      type: STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING,
      payload: null,
    });
  };

  // Login
  const login = async (google_credential, callbackFunc) => {
    try {
      const data = {
        google_credential,
      };

      const res = await axiosInstance.post("/internal/auth/login_sso", data);

      // Save auth token
      localStorage.setItem("@qrToken", res.data.token);
      dispatch({
        type: LOGIN,
        payload: res.data.user,
      });
      dispatch({
        type: SET_ENV,
        isProd: res.data.isProd,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const getDemoTeams = async (searchOptions) => {
    try {
      const { data } = await axiosInstance.get("/internal/stripe/demo_teams", {
        params: searchOptions,
      });
      dispatch({
        type: GET_DEMO_TEAMS,
        payload: data?.data?.demoTeams,
      });

      return data?.data?.demoTeams;
    } catch (error) {
      console.error(error);
    }
  };

  // Search
  const searchMembersAndTeams = async (search_term, callbackFunc) => {
    try {
      const data = { query: search_term };

      const res = await axiosInstance.post("/internal/search/query", data);

      // Save auth token
      dispatch({
        type: SEARCH,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  // Search Member
  const getMemberById = async (memberId, callbackFunc) => {
    try {
      const data = { memberId };

      const res = await axiosInstance.post("/internal/member/get_by_id", data);

      // Save auth token
      dispatch({
        type: GET_MEMBER,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const deleteMember = async (userId, userEmail) => {
    try {
      await axiosInstance.delete(`/internal/member/${userId}`);
      await searchMembersAndTeams(state.inputLookupText, () => { });

      snackbarAction({
        message: `Successfully deleted member ${userEmail}!`,
        severity: "success",
        duration: 3000,
      });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateMember = async (userId, body, cb) => {
    try {
      const { data } = await axiosInstance.patch(`/internal/member/${userId}`, body);
      const member = data?.data;

      await getMemberById(userId, () => {
        snackbarAction({
          message: "Successfully updated member!",
          severity: "success",
          duration: 3000,
        });
      });

      searchMembersAndTeams(state.inputLookupText, () => { });
      return member;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
      return { email: "" };
    }
  };

  const configureSso = async (teamId, {
    provider, metadataUrl, metadataXml, domains,
  }) => {
    try {
      await axiosInstance.post(`/internal/team/${teamId}/sso-config`, {
        provider,
        ...(metadataUrl ? { metadataUrl } : { metadataXml }),
        domains,
      });

      await getTeamById(teamId, () => { });

      snackbarAction({
        message: "SSO configuration saved!",
        severity: "success",
        duration: 3000,
      });

      return true;
    } catch (error) {
      console.log(error);
      snackbarAction({
        message: error?.response?.data?.message || "Failed to save SSO config",
        severity: "error",
        duration: 4000,
      });
      return false;
    }
  };

  const updateTeam = async (teamId, body) => {
    try {
      const { data } = await axiosInstance.patch(`/internal/team/${teamId}`, body);
      const team = data?.data;

      await getTeamById(teamId, () => {
        snackbarAction({
          message: "Successfully updated team!",
          severity: "success",
          duration: 3000,
        });
      });

      searchMembersAndTeams(state.inputLookupText, () => { });
      return team;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
      return { email: "" };
    }
  };

  const getLinksData = async (memberId, callbackFunc) => {
    try {
      const { data } = await axiosInstance.get(`/internal/member/${memberId}/links-data`);

      dispatch({
        type: GET_LINKS_DATA,
        payload: data?.data,
      });

      if (callbackFunc) {
        callbackFunc();
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const updateLinksData = async (id, params, callbackFunc) => {
    try {
      const { data } = await axiosInstance.patch(`/internal/link-data/${id}`, params);
      await getLinksData(state.member.member.id, () => { });

      snackbarAction({
        message: "Successfully updated links data!",
        severity: "success",
        duration: 3000,
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }

      return data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }

      return null;
    }
  };

  const updateMembersTeams = async (id, params, callbackFunc) => {
    try {
      const { data } = await axiosInstance.patch(`/internal/member-teams/${id}`, params);
      await getMemberById(data?.data?.mid, () => {
        snackbarAction({
          message: "Successfully updated members teams data!",
          severity: "success",
          duration: 3000,
        });
      });

      if (callbackFunc) {
        callbackFunc();
      }

      return data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }

      return null;
    }
  };

  const setMemberAdmin = async (memberId, teamId, isAdmin, callbackFunc) => {
    try {
      const data = { memberId, teamId, isAdmin };

      const res = await axiosInstance.post("/internal/member/change_admin", data);

      // Save auth token
      dispatch({
        type: GET_MEMBER,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const setEmailVerified = async (memberId, emailVerified, callbackFunc) => {
    try {
      const data = { memberId, emailVerified };

      const res = await axiosInstance.post("/internal/member/verify_email", data);

      // Save auth token
      dispatch({
        type: GET_MEMBER,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const getLoginToken = async (uid, callbackFunc) => {
    try {
      const data = { uid };

      const res = await axiosInstance.post("/internal/member/get_login_token", data);

      callbackFunc(null, res.data?.loginToken);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  // Search Team
  const getTeamById = async (teamId, callbackFunc) => {
    try {
      const data = { teamId };

      const res = await axiosInstance.post("/internal/team/get_by_id", data);

      // Save auth token
      dispatch({
        type: GET_TEAM,
        payload: res.data,
      });

      dispatch({
        type: STRIPE_CUSTOMER,
        payload: res.data.stripeCustomer,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const getHRconnectionsByTeamId = async (teamId, callbackFunc) => {
    try {
      const data = { teamId };

      const res = await axiosInstance.post("/internal/hr-sync/get_hr_connections", data);

      const token = await axiosInstance.post("/internal/hr-sync/get-admin-token", {
        teamId: res.data[0].parentTeamId,
      });
      const targetConnection = res.data.find(({ parentTeamId, integration }) => parentTeamId === teamId && integration === "microsoftTeams");

      const mappingConf = await axios(`/connections/hrSync/map-conf/${targetConnection.id}`, {
        baseURL: process.env.REACT_APP_POPLBE_URL,
        headers: {
          Authorization: token.data.token || "",
        },
      });

      dispatch({
        type: GET_HR_CONNECTIONS,
        payload: res.data,
      });

      const mappingConfData = mappingConf.data.data;

      if (targetConnection.integrationSyncConfig?.customUserAttr?.length > 0) {
        mappingConfData.msMemberKeys += `,${targetConnection.integrationSyncConfig.customUserAttr.join(",")}`;
      }
      dispatch({
        type: GET_MS_AD_MAPPING_CONF,
        payload: mappingConfData,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  // Price Config
  const getPriceConfig = async (callbackFunc) => {
    try {
      const res = await axiosInstance.get("/internal/stripe/price_config");

      dispatch({
        type: STRIPE_PRICE_CONFIG,
        priceConfig: res.data.priceConfig,
        couponConfig: res.data.couponConfig,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  /* Preview */
  const previewStripeSubscriptionNewBilling = async (data, callbackFunc) => {
    try {
      let res;
      if (data.isElcUpgrade) {
        res = await axiosInstance.post(
          `/internal/stripe/subscription/preview/upgrade/${data.teamId}`,
          data,
        );
      } else {
        res = await axiosInstance.post("/internal/stripe/subscription/preview/new_billing", data);
      }

      dispatch({
        type: STRIPE_SUBSCRIPTION_PREVIEW_NEW_BILLING,
        payload: res.data.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const previewStripeSubscriptionCurrentPricing = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post(
        "/internal/stripe/subscription/preview/current_pricing",
        data,
      );

      dispatch({
        type: STRIPE_SUBSCRIPTION_PREVIEW,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };
  const previewStripeSubscriptionCustomPricing = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post(
        "/internal/stripe/subscription/preview/custom_pricing",
        data,
      );

      dispatch({
        type: STRIPE_SUBSCRIPTION_PREVIEW,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const createDemoTeam = async (data, callbackFunc) => {
    try {
      await axiosInstance.post("/internal/stripe/demo_teams", data);

      dispatch({
        type: POST_CREATE_DEMO_TEAM,
        postDemoTeamCreated: true,
      });

      dispatch({
        type: DEMO_FLOW_DONE,
      });

      if (callbackFunc) {
        callbackFunc();
      }
    } catch (error) {
      console.error(error);
      if (callbackFunc) {
        callbackFunc(error);
      }
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateDemoTeam = async (id, params) => {
    try {
      const { data: updatedDemoTeam } = await axiosInstance.patch(
        `/internal/stripe/demo_teams/${id}`,
        { trialDays: params.trialDays },
      );

      dispatch({
        type: PATCH_UPDATE_DEMO_TEAM,
      });

      await getTeamById(updatedDemoTeam?.data?.teamId, (err) => {
        if (err) {
          alert(err);
        }
      });

      snackbarAction({
        message: "Successfully updated internal demo team!",
        severity: "success",
        duration: 3000,
      });
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const downloadQuote = async (data, callbackFunc) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        includeCheckout: data.includeCheckout,
      },
      responseType: "blob",
    };

    try {
      const res = await axiosInstance.get(`/internal/quotes/pdf/${data.teamId}`, config);

      // Response is a blob
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileURL;
      const safeCompanyName = data.companyName.replace(/[^a-zA-Z0-9]/g, "_");
      link.setAttribute("download", `Popl Teams Quote - ${safeCompanyName}.pdf`);
      document.body.appendChild(link);
      link.click();

      callbackFunc();
      return res.data;
    } catch (error) {
      callbackFunc(error);
    }
  };

  const setDemoFlowDone = (event) => {
    event.preventDefault();
    exitPostDemoFlow();

    dispatch({
      type: CHANGE_TAB,
      payload: 0,
    });
  };

  /* Subscription */
  const setTeamPricing = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/stripe/set_team_pricing", data);

      dispatch({
        type: STRIPE_SUBSCRIPTION_EXTENDED,
        payload: res.data,
      });

      if (callbackFunc) {
        callbackFunc();
      }
    } catch (error) {
      console.log(error);
      if (callbackFunc) {
        callbackFunc(error);
      }
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateSubscriptionItems = async (teamId, body, cb) => {
    try {
      const { data } = await axiosInstance.post(
        `/internal/team/${teamId}/subscription-items`,
        body,
      );

      // If we have an invoice, redirect to it
      if (data?.data?.invoice) {
        dispatch({
          type: STRIPE_SUBSCRIPTION_EXTENDED,
          payload: data.data,
        });
        changePlan(teamId);
      } else {
        snackbarAction({
          message: "Subscription items updated successfully",
          severity: "success",
          duration: 3000,
        });
      }
      await getTeamById(teamId, () => { });
    } catch (error) {
      if (cb) {
        cb();
      }
      snackbarAction({
        message: error.message || "Error upgrading to CSV Import Enrichment",
        severity: "error",
        duration: 3000,
      });
    }
  };

  /* Invoice */
  const sendInvoice = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/stripe/invoice/send", data);

      dispatch({
        type: STRIPE_INVOICE,
        payload: res.data,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  /* Payment Method */
  const addPaymentMethod = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/stripe/add_payment_method", data);

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  /* Payment Method */
  const getCustomerPaymentMethods = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/stripe/get_customer_payment_methods", data);

      dispatch({
        type: STRIPE_CUTOMER_PAYMENT_METHODS,
        payload: res.data?.paymentMethods,
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  /* Post Demo Flow */
  const createTeam = async (data, callbackFunc) => {
    try {
      if (
        data.memberEmails.filter((x) => !x.includes("@") || !x.includes(".") || x.includes(" "))
          .length >= 1
      ) {
        callbackFunc();
        return alert("Bad email(s) detected");
      }

      const res = await axiosInstance.post("/internal/team/create_team", data);

      dispatch({
        type: POST_CREATE_TEAM,
        id: res.data?.team?.id,
        email: res.data?.team?.email,
        loginToken: res.data?.loginToken,
        stripeCustomer: res.data?.stripeCustomer,
        postDemoFlowUpgrade: false,
        teamSize: res.data?.teamSize,
      });

      await getTeamById(res.data?.team?.id, () => {
        snackbarAction({
          message: "Successfully created new team!",
          severity: "success",
          duration: 3000,
        });
      });

      callbackFunc();
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data && error.response.data.message) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 5000,
        });
        callbackFunc();
      } else {
        alert("Server error - please refresh");
        callbackFunc();
      }
    }
  };

  const changeTeamPlan = async (teamId, teamEmail, stripeCustomer, teamSize) => {
    dispatch({
      type: POST_UPGRADE_TEAM,
      email: teamEmail,
      id: teamId,
      stripeCustomer,
      postDemoFlowUpgrade: true,
      teamSize,
    });
  };

  const changePlan = () => {
    changeTeamPlan(
      state.team.team.id,
      state.team.team.email,
      state.team.stripeCustomer,
      getMemberCount(state.team),
    );
  };

  const linkTeamToStripeSub = async (callbackFunc) => {
    dispatch({
      type: DEMO_FLOW_DONE,
    });

    callbackFunc();
  };

  const exitPostDemoFlow = () => {
    resetState();
    resetDemoTeamState();
    resetTeamState();
    dispatch({
      type: POST_CREATE_TEAM,
      email: "",
      id: 0,
      priceId: "",
      postDemoFlowUpgrade: false,
      postDemoFlowFinished: false,
      loginToken: null,
      teamSize: 0,
    });
    dispatch({
      type: STRIPE_CUTOMER_PAYMENT_METHODS,
      payload: null,
    });
  };

  const markInvoiceSent = () => {
    dispatch({
      type: MARK_INVOICE_SENT,
    });
  };

  const setPostFlowEmail = (email) => {
    dispatch({
      type: POST_SET_EMAIL_STEP,
      email,
    });
  };

  /* Quote */
  const generatePdfQuote = async (data, callbackFunc) => {
    try {
      const config = {
        responseType: "blob",
      };
      const res = await axiosInstance.post("/internal/quotes/make_pdf", data, config);

      // Response is a blob
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileURL;
      const safeCompanyName = data.companyName.replace(/[^a-zA-Z0-9]/g, "_");
      link.setAttribute("download", `Popl Teams Quote - ${safeCompanyName}.pdf`);
      document.body.appendChild(link);
      link.click();

      callbackFunc();
    } catch (error) {
      // Attempt to decode blob as JSON
      error.response.data
        .text()
        .then((text) => {
          try {
            text = JSON.parse(text);
          } catch (e) {
            console.log(e);
          }
          if (text && text.msg) {
            callbackFunc(text.msg);
          } else {
            callbackFunc(error);
          }
        })
        .catch((err) => {
          console.log(err);
          callbackFunc(error);
        });
    }
  };

  /* Team Order */
  const addTeamOrder = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/team/add_order", data);

      callbackFunc();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  // Get AD gorup users
  const getAdGroups = async (groupIds, connectionUid, cb) => {
    try {
      const { data } = await axiosInstance.post("/internal/hr-sync/get_token", {
        uid: connectionUid,
      });
      const groups = [];
      for (const groupId of groupIds) {
        const { data: group } = await axiosParagonInstance.get(
          `/groups?$filter=id eq '${groupId}'&$select=id,displayName`,
          {
            headers: { Authorization: `Bearer ${data.token}` },
          },
        );
        groups.push(group.value[0]);
      }

      dispatch({
        type: GET_AD_GROUPS,
        payload: groups,
      });
      cb();
    } catch (error) {
      cb();
      console.log(error);
    }
  };

  const getMemberIntegrationConnections = async (memberId, callbackFunc) => {
    try {
      const { data } = await axiosInstance.get(
        `/internal/member/${memberId}/integration-connections`,
      );

      dispatch({
        type: GET_INTEGRATION_CONNECTIONS,
        payload: data?.data,
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const getTeamIntegrationConnections = async (teamId, callbackFunc) => {
    try {
      const { data } = await axiosInstance.get(`/internal/team/${teamId}/integration-connections`);

      dispatch({
        type: GET_INTEGRATION_CONNECTIONS,
        payload: data?.data,
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const getDevicesForMember = async (memberId, callbackFunc) => {
    try {
      const { data } = await axiosInstance.get(`/internal/member/${memberId}/popls`);

      dispatch({
        type: GET_DEVICES_FOR_MEMBER,
        payload: data?.data,
      });

      if (callbackFunc) {
        callbackFunc();
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const registerDevice = async (body, callbackFunc) => {
    try {
      const { data } = await axiosInstance.post("/internal/popls", body);
      await getDevicesForMember(data?.data?.mid, () => { });

      snackbarAction({
        message: "Successfully registered device!",
        severity: "success",
        duration: 3000,
      });

      if (callbackFunc) {
        callbackFunc();
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }

      return null;
    }
  };

  const getTeamSalesforceData = async (teamId, callbackFunc) => {
    try {
      const { data } = await axiosInstance.get(`/internal/team/${teamId}/salesforce`);

      dispatch({
        type: GET_TEAM_SALESFORCE_DATA,
        payload: data?.data,
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const getMemberCrmExportLogs = async (memberId, query, callbackFunc) => {
    try {
      const params = {};
      if (query) {
        params.query = query;
      }

      const { data } = await axiosInstance.get(`/internal/member/${memberId}/crm-export-logs`, {
        params,
      });

      dispatch({
        type: GET_MEMBER_CRM_EXPORT_LOGS,
        payload: data?.data || [],
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const getTeamCrmExportLogs = async (teamId, query, callbackFunc) => {
    try {
      const params = {};
      if (query) {
        params.query = query;
      }

      const { data } = await axiosInstance.get(`/internal/team/${teamId}/crm-export-logs`, {
        params,
      });

      dispatch({
        type: GET_TEAM_CRM_EXPORT_LOGS,
        payload: data?.data || [],
      });

      if (callbackFunc) {
        callbackFunc(null, data);
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }
    }
  };

  const updateMemberLinksData = async (memberId, params, callbackFunc) => {
    try {
      await axiosInstance.patch(`/internal/member/${memberId}/links-data`, params);

      await getLinksData(memberId, () => { });
      snackbarAction({
        message: "Successfully updated lead capture mode!",
        severity: "success",
        duration: 3000,
      });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }

      if (callbackFunc) {
        callbackFunc(error);
      }

      return null;
    }
  };

  const updateTeamHubspotProperties = async (teamId, body) => {
    try {
      await axiosInstance.post(`/internal/team/${teamId}/hubspot`, body);
      await getTeamById(teamId, () => {
        snackbarAction({
          message: "Updating members hubspot marketing in background...",
          severity: "success",
          duration: 3000,
        });
      });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateMemberHubspotProperties = async (memberId, body) => {
    try {
      await axiosInstance.post(`/internal/member/${memberId}/hubspot`, body);
      await getMemberById(memberId, () => {
        snackbarAction({
          message: "Successfully updated hubspot pricing!",
          severity: "success",
          duration: 3000,
        });
      });
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateSyncConfig = async (body) => {
    try {
      await axiosInstance.put("/internal/hr-sync/update-sync-config", body);
      dispatch({
        type: UPDATE_HR_CONNECTION_SYNC_CONF,
        payload: body,
      });
    } catch (error) {
      console.log(error);
    }
  };

  /* Team Order */
  const setFirewallIp = async (data, callbackFunc) => {
    try {
      const res = await axiosInstance.post("/internal/firewall/firewall_update_ip", data);
      callbackFunc();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        callbackFunc(error.response.data.message);
      } else {
        callbackFunc(error);
      }
    }
  };

  const previewSubscription = async (payload, signal) => {
    try {
      const { data } = await axiosInstance.post("/internal/v2/subscriptions/preview", payload, {
        signal,
      });
      return data?.data;
    } catch (error) {
      if (error.name === "AbortError" || error.name === "CanceledError") {
        return;
      }
      console.error("Preview fetch failed:", error);
    }
  };

  const previewSubscriptionUpdates = async (teamId, payload, signal) => {
    try {
      const { data } = await axiosInstance.post(
        `/internal/v2/teams/${teamId}/subscriptions/preview`,
        payload,
        {
          signal,
        },
      );
      return data?.data;
    } catch (error) {
      if (error.name === "AbortError" || error.name === "CanceledError") {
        return;
      }
      console.error("Preview fetch failed:", error);
    }
  };

  const createOrUpdateTeamSubscription = async (teamId, payload, isUpdate) => {
    try {
      let url = `/internal/v2/teams/${teamId}/subscriptions`;
      const { data } = await axiosInstance({
        method: isUpdate ? "put" : "post",
        url,
        data: payload,
      });

      await getTeamById(teamId, () => { });

      snackbarAction({
        message: "Successfully updated subscription!",
        severity: "success",
        duration: 3000,
      });

      return data?.data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const updateTeamSubscription = async (teamId, body) => {
    try {
      const { data } = await axiosInstance.patch(
        `/internal/v2/teams/${teamId}/subscriptions`,
        body,
      );

      await getTeamById(teamId, () => { });
      snackbarAction({
        message: "Successfully updated subscription",
        severity: "success",
        duration: 3000,
      });
      return data?.data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
      return { email: "" };
    }
  };

  const createQuote = async (data) => {
    try {
      const config = {
        responseType: "blob",
      };

      const res = await axiosInstance.post("/internal/v2/quotes", data, config);
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `Popl Teams Quote - ${new Date().toISOString()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const downloadTeamQuote = async (teamId) => {
    try {
      const config = {
        responseType: "blob",
      };

      const res = await axiosInstance.get(`/internal/v2/teams/${teamId}/quote`, config);

      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `Popl Teams Quote - ${new Date().toISOString()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  const getSubscriptionFormPrefillForTeam = async (teamId) => {
    try {
      const { data } = await axiosInstance.get(
        `/internal/v2/teams/${teamId}/subscriptions/prefill`,
      );
      return data?.data;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        snackbarAction({
          message: error.response.data?.message
            ? error.response.data?.message
            : JSON.stringify(error.response.data),
          severity: "error",
          duration: 3000,
        });
      }
    }
  };

  return (
    <mainContext.Provider
      value={{
        user: state.user,
        currentTab: state.currentTab,
        listOfApps: state.listOfApps,
        stripe_customer: state.stripe_customer,
        stripe_customer_payment_methods: state.stripe_customer_payment_methods,
        stripe_subscription_preview: state.stripe_subscription_preview,
        stripe_subscription_preview_new_billing: state.stripe_subscription_preview_new_billing,
        stripe_subscription_extended: state.stripe_subscription_extended,
        stripe_invoice: state.stripe_invoice,
        search_results: state.search_results,
        postDemoFlowStoredEmail: state.postDemoFlowStoredEmail,
        postDemoFlowStoredTeamId: state.postDemoFlowStoredTeamId,
        postDemoFlowStoredTeamSize: state.postDemoFlowStoredTeamSize,
        postDemoFlowStoredLoginToken: state.postDemoFlowStoredLoginToken,
        postDemoFlowStoredpriceId: state.postDemoFlowStoredpriceId,
        postDemoFlowUpgrade: state.postDemoFlowUpgrade,
        postDemoTeamCreated: state.postDemoTeamCreated,
        invoiceSent: state.invoiceSent,
        postDemoFlowFinished: state.postDemoFlowFinished,
        member: state.member,
        team: state.team,
        hrConnections: state.hrConnections,
        integrationConnections: state.integrationConnections,
        memberTeam: state.memberTeam,
        linksData: state.linksData,
        getLinksData,
        price_config: state.price_config,
        coupon_config: state.coupon_config,
        prePostDemoFlowStoredEmail: state.prePostDemoFlowStoredEmail,
        isProd: state.isProd,
        adGroups: state.adGroups,
        hrMappingConf: state.hrMappingConf,
        login,
        logout,
        changeTab,
        previewStripeSubscriptionCurrentPricing,
        previewStripeSubscriptionNewBilling,
        previewStripeSubscriptionCustomPricing,
        setTeamPricing,
        createDemoTeam,
        updateDemoTeam,
        sendInvoice,
        resetState,
        resetDemoTeamState,
        resetTeamState,
        resetMemberState,
        searchMembersAndTeams,
        createTeam,
        exitPostDemoFlow,
        markInvoiceSent,
        linkTeamToStripeSub,
        getMemberById,
        setMemberAdmin,
        snackbarData: state.snackbarData,
        snackbarAction,
        setEmailVerified,
        getTeamById,
        getPriceConfig,
        changeTeamPlan,
        changePlan,
        setPostFlowEmail,
        getLoginToken,
        generatePdfQuote,
        addTeamOrder,
        addPaymentMethod,
        getCustomerPaymentMethods,
        getHRconnectionsByTeamId,
        getAdGroups,
        getMemberIntegrationConnections,
        getTeamIntegrationConnections,
        updateSyncConfig,
        setFirewallIp,
        downloadQuote,
        setDemoFlowDone,
        deleteMember,
        updateMember,
        onChangeInputLookupText,
        inputLookupText: state.inputLookupText,
        getDemoTeams,
        AEDemoTeams: state.AEDemoTeams,
        updateTeam,
        updateLinksData,
        updateMembersTeams,
        registerDevice,
        getDevicesForMember,
        memberDevices: state.memberDevices,
        getTeamSalesforceData,
        teamSalesforceData: state.teamSalesforceData,
        getMemberCrmExportLogs,
        getTeamCrmExportLogs,
        crmExportLogs: state.crmExportLogs,
        updateMemberLinksData,
        resetPreviewState,
        updateSubscriptionItems,
        updateTeamHubspotProperties,
        updateMemberHubspotProperties,
        previewSubscription,
        previewSubscriptionUpdates,
        createOrUpdateTeamSubscription,
        updateTeamSubscription,
        downloadTeamQuote,
        getSubscriptionFormPrefillForTeam,
        createQuote,
        configureSso,
      }}
    >
      {props.children}
    </mainContext.Provider>
  );
};

export default MainState;
